window.onload = function () {
    let children = document.querySelectorAll('.jdgm-rev');
    children.forEach(function (child) {
        let rat = child.querySelector('.jdgm-rev__rating')
        let rat_value = rat.getAttribute('data-score')
        if (rat_value === '1') {
            child.style.display = 'none'
        }
    });
};